import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'
import { ProductCogs } from 'types/resources/productCogs'

import { CerebroResourceResponse } from '../types'

export const getProductSkuCogs = (
    sku: string
): Promise<CerebroResourceResponse<ProductCogs>> =>
    orgScopedApiClient.get(`/api/product_skus/${sku}/cogs/`)

export const putProductSkuCogs = (
    sku: string,
    data: Pick<ProductCogs, 'cogs'>
): Promise<CerebroResourceResponse<ProductCogs>> =>
    orgScopedApiClient.put(`/api/product_skus/${sku}/cogs/`, data)

export interface ProductSkuCogsTemplateFilter {
    asin__in?: string
    marketplace__in?: string
    sku__in?: string
    complex_label_filter?: string
}

export const getProductCogsExportAsyncExport = (
    params: ProductSkuCogsTemplateFilter
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.get(`/api/product_cogs/export/async/`, {
        params,
    })
